import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/map';
import { Headers, RequestOptions, Response, Http } from '@angular/http';
import { AuthService } from '../shared/services/auth.service';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class ReportsService {

  constructor(
    private _http:Http,
    private _authService:AuthService
  ) { }

  getCutLog(params) {
    const url = `${environment.apiUrl}reports/cutlog`;
    const token = this._authService.getToken();
    const headers = new Headers({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+token
    });
    const options = new RequestOptions({ headers: headers });
    return this._http.post(url, params, options)
      .map( (resp: Response) => {
        return resp.json()
      })
      .catch( (error: any) =>  {
        return Observable.throw(error)
      })
  }

  getDeliveries(params) {
    const url = `${environment.apiUrl}reports/deliveries`;
    const token = this._authService.getToken();
    const headers = new Headers({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+token
    });
    const options = new RequestOptions({ headers: headers });
    return this._http.post(url, params, options)
      .map( (resp: Response) => {
        return resp.json()
      })
      .catch( (error: any) =>  {
        return Observable.throw(error)
      })
  }

  getHcustomers() {
    const url = `${environment.apiUrl}reports/hcustomers`;
    const token = this._authService.getToken();
    const headers = new Headers({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+token
    });
    const options = new RequestOptions({ headers: headers });
    return this._http.get(url, options)
      .map( (resp: Response) => {
        return resp.json()
      })
      .catch( (error: any) =>  {
        return Observable.throw(error)
      })
  }

  getHestimates() {
    const url = `${environment.apiUrl}reports/hestimates`;
    const token = this._authService.getToken();
    const headers = new Headers({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+token
    });
    const options = new RequestOptions({ headers: headers });
    return this._http.get(url, options)
      .map( (resp: Response) => {
        return resp.json()
      })
      .catch( (error: any) =>  {
        return Observable.throw(error)
      })
  }
}



// WEBPACK FOOTER //
// ./src/app/reports/reports.service.ts